const connectionState = Object.freeze({
    notConnected: 0,
    connectionLost: 1,
    connected: 2
})
export default connectionState;